import styled from 'styled-components';
import MyImage from '../assets/images/my-image.jpeg';

const MainContentWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #000000;
  color: #828282;
  text-align: center;
  margin: 0rem;
  padding: 5rem;
  position: relative;

  @media (max-width: 1200px) {
    padding: 4rem 2rem;
  }

  @media (max-width: 768px) {
    padding: 3rem 1.5rem;
  }

  @media (max-width: 400px) {
    padding: 3rem 1rem;
    align-items: flex-start;
    text-align: left;
  }
`;

const StyledImage = styled.img`
  width: 100%;
  max-width: 310px;
  margin-left: 16rem;

  @media (max-width: 1200px) {
    max-width: 250px;
    margin-left: 0;
  }

  @media (max-width: 992px) {
    max-width: 200px;
    margin-left: 0;
  }

  @media (max-width: 400px) {
    max-width: 180px;
    margin: 0 auto 1rem auto;
  }
`;

const Heading1 = styled.h1`
  font-size: 45px;
  font-weight: bold;
  margin-top: -90px;
  margin-left: -830px;
  color: #828282;

  @media (max-width: 1200px) {
    font-size: 36px;
    margin-left: 0;
    margin-top: 1rem;
  }

  @media (max-width: 768px) {
    font-size: 30px;
  }

  @media (max-width: 400px) {
    font-size: 24px;
    margin-left: 0;
    margin-top: 1rem;
  }
`;

const Heading2 = styled.h2`
  font-size: 29px;
  margin-top: -2rem;
  margin-left: -788px;
  color: #828282;

  @media (max-width: 1200px) {
    font-size: 24px;
    margin-left: 0;
    margin-top: 0.5rem;
  }

  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-width: 400px) {
    font-size: 15px;
    margin-left: 0;
  }
`;

const Text = styled.p`
  font-size: 17px;
  margin-top: -1rem;
  margin-left: -18px;
  color: #828282;

  @media (max-width: 1200px) {
    font-size: 16px;
    margin-left: 0;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 400px) {
    font-size: 13px;
    margin-left: 0;
    margin-top: 0.5rem;
  }
`;

const Button = styled.button`
  margin-top: 6px;
  margin-left: -53rem;
  padding: 0.9rem 2rem;
  background-color: #828282;
  color: #000000;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #f5c32c;
  }

  @media (max-width: 1200px) {
    margin-left: 0;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 0.8rem 1.5rem;
  }

  @media (max-width: 400px) {
    font-size: 0.75rem;
    padding: 0.5rem 1.2rem;
    align-self: flex-start;
  }
`;

const MainContent = ({ projectsRef }) => {
  const handleButtonClick = () => {
    projectsRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <MainContentWrapper>
      <StyledImage src={MyImage} alt="My Image" />
      <Heading1>Hi, I'm Aditi,</Heading1>
      <Heading2>A Software Developer,</Heading2>
      <Text>
        I'm a Computer Science Engineer skilled in mobile app development using Kotlin & React Native.
        Let's code the future, one app at a time ( ᐛ )ᕗ
      </Text>
      <Button onClick={handleButtonClick}>FEATURED PROJECTS</Button>
    </MainContentWrapper>
  );
};

export default MainContent;
